
  // Scroll to top script start 

    //Get the button
    //var mybutton = document.getElementById("myBtn");

    // When the user scrolls down 50px from the top of the document, show the button

   // if(mybutton != null){
   //   window.onscroll = function() {scrollFunction()};

    //  function scrollFunction() {
     //   if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
       //   mybutton.style.display = "block";
      //  } else {
       //   mybutton.style.display = "none";
     //   }
     // }

      // When the user clicks on the button, scroll to the top of the document
     // function topFunction() {
     //   document.body.scrollTop = 0;
     //   document.documentElement.scrollTop = 0;
     // }
      //   Scroll to top script end 
  //  }
 
$(document).ready(function(){
  var damderIsHebrew = ((document.documentElement.lang || '').toLowerCase().indexOf('he') === 0) || document.documentElement.dir === 'rtl';
  // Give the opening "30 years" phrase its own editorial Hebrew face without
  // changing the translated theme setting or the rest of the headline.
  $('.damder_home_section1 .home-top-heading').each(function () {
    var node = this.firstChild;
    if (node && node.nodeType === 3 && node.nodeValue.trim()) {
      var mark = document.createElement('span');
      mark.className = 'damder-years-mark';
      mark.textContent = node.nodeValue;
      this.replaceChild(mark, node);
    }
  });

  function syncContactPreference($scope, shouldFocus) {
    var method = $scope.find('input[name="contact[preferred_contact]"]:checked').val();
    var $email = $scope.find('.damder-contact-email');
    var $phone = $scope.find('.damder-contact-phone');

    $email.prop('required', method === 'email').attr('aria-required', method === 'email' ? 'true' : 'false');
    $phone.prop('required', true).attr('aria-required', 'true');
    $scope.find('[data-contact-field]').removeClass('is-required');
    $phone.closest('[data-contact-field]').addClass('is-required');
    var $help = $scope.find('.damder-contact-help');
    var requiredCopy = $help.attr('data-required-copy');
    if (requiredCopy) $help.text(requiredCopy);

    if (method) {
      var $target = method === 'email' ? $email : $phone;
      $target.closest('[data-contact-field]').addClass('is-required');
      if (shouldFocus) window.setTimeout(function () { $target.trigger('focus'); }, 80);
    }
  }

  $('[data-damder-contact-form]').each(function () { syncContactPreference($(this), false); });
  $(document).on('change', '[data-damder-contact-form] input[name="contact[preferred_contact]"]', function () {
    syncContactPreference($(this).closest('[data-damder-contact-form]'), true);
  });
  $(document).on('submit', '.popup form[action*="contact"]', function () {
    syncContactPreference($(this).find('[data-damder-contact-form]'), false);
  });

  function enforceStandaloneContactPhone() {
    var $phone = $('#ContactForm').find('input[name="contact[phone]"]');
    $phone.prop('required', true).attr('aria-required', 'true');
  }

  enforceStandaloneContactPhone();
  $(document).on('change submit', '#ContactForm [data-damder-contact-method], #ContactForm', function () {
    enforceStandaloneContactPhone();
  });

  // The editorial gallery advances on its own, but never while a visitor is
  // watching a video. Resuming is tied to pause/end so user intent wins.
  $(document).on('play', '.damder_home_section4 video', function () {
    var $gallery = $(this).closest('.damder_home_section4').find('.slides-col.slick-initialized');
    if ($gallery.length) $gallery.slick('slickPause');
  });
  $(document).on('pause ended', '.damder_home_section4 video', function () {
    var $gallery = $(this).closest('.damder_home_section4').find('.slides-col.slick-initialized');
    if ($gallery.length) $gallery.slick('slickPlay');
  });

  function gallerySlidesToShow() {
    if (window.innerWidth < 600) return 1;
    if (window.innerWidth < 960) return 2;
    return 3;
  }

  function syncGalleryLayout() {
    $('.damder_home_section4 .slides-col.slick-initialized').each(function () {
      var $slider = $(this);
      var slidesToShow = gallerySlidesToShow();

      if (Number($slider.attr('data-damder-slides-to-show')) === slidesToShow) return;
      $slider.attr('data-damder-slides-to-show', slidesToShow);
      $slider.slick('slickSetOption', {
        slidesToShow: slidesToShow,
        slidesToScroll: 1
      }, true);
      $slider.slick('setPosition');
    });
  }

  window.setTimeout(function () {
    $('.damder_home_section4 .slides-col.slick-initialized').each(function () {
      var $slider = $(this);
      var damderReduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      $slider.slick('slickSetOption', {
        autoplay: !damderReduceMotion,
        autoplaySpeed: 4200,
        pauseOnHover: false,
        pauseOnFocus: true
      }, false);
      var slideWord = damderIsHebrew ? 'שקופית' : 'Slide';
      var previousWord = damderIsHebrew ? 'הקודם' : 'Previous';
      var nextWord = damderIsHebrew ? 'הבא' : 'Next';
      $slider.find('.slick-dots button').each(function (index) {
        $(this).text(slideWord + ' ' + (index + 1)).attr('aria-label', slideWord + ' ' + (index + 1));
      });
      $slider.find('.prev-icon-mob').attr({ role: 'button', tabindex: '0', 'aria-label': previousWord }).find('.sr-only').text(previousWord);
      $slider.find('.next-icon-mob').attr({ role: 'button', tabindex: '0', 'aria-label': nextWord }).find('.sr-only').text(nextWord);
      if (damderReduceMotion) $slider.slick('slickPause');
      else $slider.slick('slickPlay');
    });
    syncGalleryLayout();
  }, 700);

  var galleryResizeTimer;
  $(window).on('resize orientationchange', function () {
    window.clearTimeout(galleryResizeTimer);
    galleryResizeTimer = window.setTimeout(syncGalleryLayout, 140);
  });

  $(document).on('keydown', '.damder_home_section4 .prev-icon-mob, .damder_home_section4 .next-icon-mob', function (event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      $(this).trigger('click');
    }
  });

  // A light section assist: it reacts only when a deliberate wheel gesture is
  // already approaching the next section. It never runs on load and never
  // skips through a long section before the visitor reaches its boundary.
  if (window.innerWidth >= 1024 &&
      window.matchMedia &&
      !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    var snapBusy = false;
    var sectionSelector = [
      '.damder_home_section1',
      '.damder_home_section2',
      '.damder-b2b-value',
      '.damder-you-are-etrog',
      '.damder-success-path',
      '.damder_home_section3',
      '.damder_home_section3-2',
      '.damder_home_section3-3',
      '.damder_home_section4',
      '.damder_home_section5'
    ].join(',');

    window.addEventListener('wheel', function (event) {
      if (snapBusy || Math.abs(event.deltaY) < 28 ||
          $('.popup:visible').length ||
          $('.damder_home_section4 video').filter(function () { return !this.paused; }).length) return;

      var sections = Array.prototype.slice.call(document.querySelectorAll(sectionSelector));
      var target = null;
      var viewport = window.innerHeight;

      if (event.deltaY > 0) {
        target = sections.find(function (section) {
          var rect = section.getBoundingClientRect();
          return rect.top > viewport * .32 && rect.top < viewport * 1.08;
        });
      } else {
        for (var index = sections.length - 1; index >= 0; index -= 1) {
          var rect = sections[index].getBoundingClientRect();
          if (rect.top < -80 && rect.bottom > -20 && rect.bottom < viewport * .72) {
            target = sections[index];
            break;
          }
        }
      }

      if (!target) return;
      event.preventDefault();
      snapBusy = true;
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      window.setTimeout(function () { snapBusy = false; }, 850);
    }, { passive: false });
  }

  // Add smooth scrolling to all links
  $("a.scroll-btn").on('click', function(event) {

    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      var $target = $(hash);

      if (!$target.length) return;

      // Animate only after an intentional click. Do not persist the hash, so
      // revisiting or refreshing the homepage always opens at the hero.
      $('html, body').stop(true).animate({
        scrollTop: $target.offset().top
      }, 800);
    } // End if
  });

  // Product pages in the original catalog are no longer published. Card links
  // therefore open the active quote page and preserve the requested grade.
  var gradeParams = new URLSearchParams(window.location.search);
  var requestedGrade = gradeParams.get('grade');
  var allowedGrades = ['meyuhadim', 'mehudar-xx', 'mehudar-x'];

  var requestedPriceList = gradeParams.get('price_list');
  if ((requestedGrade && allowedGrades.indexOf(requestedGrade) !== -1) || requestedPriceList === '1') {
    var $gradePopup = $('.popup#price-request').first();
    var $gradeField = $gradePopup.find('#' + requestedGrade).first();
    var gradeLabels = damderIsHebrew ? {
      'meyuhadim': 'מיוחדים',
      'mehudar-xx': 'מהודר א״א',
      'mehudar-x': 'מהודר א׳'
    } : {
      'meyuhadim': 'Meyuhadim',
      'mehudar-xx': 'Mehudar AA',
      'mehudar-x': 'Mehudar A'
    };
    var gradePrefix = damderIsHebrew ? 'הדרגה שנבחרה: ' : 'Selected grade: ';
    var priceListLabel = damderIsHebrew ? 'בקשת מחירון מעודכן' : 'Current wholesale information request';

    if (requestedGrade) {
      $gradePopup.find('#DamderSelectedGrade').val(gradeLabels[requestedGrade]);
      $gradePopup.find('.selected-grade').text(gradePrefix + gradeLabels[requestedGrade]);
      $gradeField.closest('.form-group').addClass('damder-grade-focus');
    } else {
      $gradePopup.find('#DamderSelectedGrade').val(priceListLabel);
      $gradePopup.find('.selected-grade').text(priceListLabel).show();
    }

    if ($gradePopup.length && typeof popupOpenClose === 'function') {
      popupOpenClose($gradePopup);
      if ($gradeField.length) window.setTimeout(function () { $gradeField.trigger('focus'); }, 120);
    }
  }
});  


var damderProductIsHebrew = ((document.documentElement.lang || '').toLowerCase().indexOf('he') === 0) || document.documentElement.dir === 'rtl';
$('.shopify-payment-button .shopify-payment-button__button--unbranded').html(damderProductIsHebrew ? 'רכישה עכשיו' : 'PURCHASE NOW');
$('.quantity label').html(damderProductIsHebrew ? 'כמות' : 'Qty');
$('button.btn.product-form__cart-submit.btn--secondary-accent span').html('<span class="cart-btn-icon"><img src="https://cdn.shopify.com/s/files/1/0452/2475/5361/files/shopping-bag.png?v=1597631820" style="width:32px; height: 32px;"> ' + (damderProductIsHebrew ? 'הוספה לסל' : 'ADD TO CART') + '</span>');



if (window.matchMedia &&
    window.matchMedia('(hover: hover) and (pointer: fine)').matches &&
    !document.documentElement.classList.contains('damder-rtl') &&
    !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
  window.CustomCursor = new(function() {
	const self = this;
	const css = `
		 html{cursor: none;}
		.customCursor {
            color: #e77e33;
            border: 2px solid #e77e33;
            background: #f0ffff00;
            position: absolute;
            width: 40px;
            height: 40px;
            border-radius: 50%;
			z-index: 99999999;
			pointer-events: none;
			transition-timing-function: ease-out;
			animation: sursorAnim .5s infinite alternate;
		}
        

	`;
    
	//Creating Style
	const style = document.createElement('style');
    style.appendChild(document.createTextNode(css));
    document.querySelector('head').appendChild(style);

	//Creating Cursor
	const cursor = document.createElement('div');
	cursor.className = "customCursor";
	document.querySelector('body').appendChild(cursor);
    
	//Creating Logic
	document.addEventListener("mousemove", e => {
	  const {pageX, pageY} = e;
      cursor.setAttribute(`style`, `top: ${pageY - 20}px; left: ${pageX - 20}px;`);
	});
    

	
	
  });
}
